var exports = {
  "n": "x4ddf2309--da8343--link",
};

module.exports = exports;
